import { useState } from "react";
import { Bordered, FormEntry } from "components";
import { useForm } from "react-hook-form";
import apiService from "services/api";
import { useNotificationContext } from "contexts";
import { FiLoader } from "react-icons/fi";
import { useMutation } from "react-query";

const EditRecordType = {
	ADD: "ADD",
	REMOVE: "REMOVE",
};

const EditRecordHoursMap = {
	[EditRecordType.ADD]: 1, // negative 1 because it is a debit for hours in duration
	[EditRecordType.REMOVE]: -1, // positive 1 because it is a credit for hours in duration
};
const EditHours = ({ studentCourseRecord, refetch, close }) => {
	const { createNotification } = useNotificationContext();
	const {
		register,
		handleSubmit,
		formState: { errors },
	} = useForm({ defaultValues: { hours: null, remark: null, recordType: EditRecordType.REMOVE } });

	const saveEdit = useMutation(
		(data) => {
			const formData = { ...data, hours: EditRecordHoursMap[data.recordType] * +data.hours };
			return apiService.student.editStudentCourse(studentCourseRecord?.id, formData);
		},
		{
			onSuccess: () => {
				createNotification({ type: "success", message: "Successfully edited student course hours" });
				refetch();
			},
			onError: (err) => createNotification({ type: "danger", message: "Failed to edit student course hours: " + err.message }),
		}
	);

	return (
		<div>
			<Bordered.Box>
				<Bordered.Entry label="Hours Left" value={studentCourseRecord?.hoursLeft} inline />
			</Bordered.Box>
			<form onSubmit={handleSubmit((data) => saveEdit.mutate(data))} id="editHoursForm" className="mt-4">
				<div className="d-flex mb-3" style={{ columnGap: 10 }}>
					<FormEntry
						register={register}
						name="hours"
						marginClass="none"
						error={errors?.hours}
						type="number"
						required={true}
						formLabel="Hours"
						placeholder="Hours to add or minus"
					/>
					<div className="d-flex pb-2" style={{ columnGap: 10 }}>
						<div className="d-flex align-items-center">
							<input type="radio" {...register("recordType")} id="addRecordType" value={EditRecordType.ADD} />
							<span className="text-primary ml-1" htmlFor="addRecordType">
								Add
							</span>
						</div>
						<div className="d-flex align-items-center">
							<input type="radio" {...register("recordType")} value={EditRecordType.REMOVE} />
							<span className="text-primary ml-1" htmlFor="addRecordType">
								Deduct
							</span>
						</div>
					</div>
				</div>

				<FormEntry
					register={register}
					error={errors?.remark}
					name="remark"
					type="text"
					required={true}
					formLabel="Remark"
					placeholder="Reason for crediting/debiting course hours"
					marginClass="mb-0"
				/>
				<div className="text-right mt-4">
					<button type="submit" className="btn btn-success" disabled={saveEdit.isLoading}>
						{saveEdit.isLoading ? <FiLoader size={20} className="animate-spin" /> : "Submit"}
					</button>
				</div>
			</form>
		</div>
	);
};

export default EditHours;
